import { Box } from '@mui/material';

const DescriptionContainer = ({ children }: any) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
      }}
    >
      {children}
    </Box>
  );
};

export default DescriptionContainer;
